module.exports = __webpack_public_path__ + "media/images/faq/brand2-4-3543fe0a7a1b2e3683c6b0052befbefd.png";